import React from 'react';
import { OutboundLink } from 'gatsby-plugin-google-analytics';

function clientRandomizer(props) {
  const millsAds = [
    {
      image: '/mar-apr-2023/sponsors/Eccles-Symphony-ad.jpg',
      link: 'https://www.gsecclesfoundation.org/?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing',
      alt: 'George S. and Dolores Doré Eccles Foundation',
      class: 'webFormat',
    },
    {
      image: '/mar-apr-2023/sponsors/squatters.jpg',
      link: 'https://www.saltlakebrewingco.com/?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing+salt+lake+brewing+company',
      alt: 'Salt Lake Brewing Company',
      class: 'webFormat',
    },
    {
      image: '/mar-apr-2023/sponsors/high-school-clubs.jpg',
      link: 'https://www.classical89.org?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing+high+school+clubs',
      alt: 'Utah Symphony High School Clubs',
      class: 'webFormat',
    },
    {
      image: '/mar-apr-2023/sponsors/thierry-final.jpg',
      link: 'https://utahsymphony.org/tickets/concerts-by-series/?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing+thierry-finals',
      alt: 'Thierrys Final Performances as Music Director',
      class: 'webFormat',
    },
    {
      image: '/mar-apr-2023/sponsors/noorda.jpg',
      link: 'https://www.uvu.edu/thenoorda?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing+Noorda',
      alt: 'UVU The Noorda',
      class: 'webFormat',
    },
    {
      image: '/mar-apr-2023/sponsors/pre-concert.jpg',
      link: 'https://www.utahsymphony.org/?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing+preconcerts',
      alt: 'Pre-concert Talks',
      class: 'webFormat',
    },
    {
      image: '/mar-apr-2023/sponsors/classical-89.jpg',
      link: 'https://www.classical89.org?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing+salt+lake+brewing+company',
      alt: 'Classical 89',
      class: 'webFormat',
    },
    {
      image: '/mar-apr-2023/sponsors/grand-america.jpg',
      link: 'https://www.grandamerica.com/?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing+grand+america',
      alt: 'Grand America',
      class: 'webFormat',
    },
    {
      image: '/mar-apr-2023/sponsors/steve-jobs.jpg',
      link: 'https://utahopera.org/event/id/28248/?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing+steve+jobs',
      alt: 'Utah Opera The revolution of Steve Jobs',
      class: 'webFormat',
    },
    {
      image: '/mar-apr-2023/sponsors/upcoming-season.jpg',
      link: 'https://usuo.org/season-subscription-waitlist-sign-up?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing+upcoming-season',
      alt: 'Utah Symphony Upcoming Season',
      class: 'webFormat',
    },
    {
      image: '/mar-apr-2023/sponsors/star-wars.jpg',
      link: 'https://utahsymphony.org/event/id/28222/?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing+star+wars',
      alt: 'Utah Symphony Upcoming Season',
      class: 'webFormat',
    },
    {
      image: '/mar-apr-2023/sponsors/sun-valley.jpg',
      link: 'https://sunvalley.com/?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing+sun+valley',
      alt: 'Utah Symphony Upcoming Season',
      class: 'webFormat',
    },
    {
      image: '/mar-apr-2023/sponsors/pago.jpg',
      link: 'https://www.pagoslc.com/?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing+salt+lake+brewing+company',
      alt: 'Pago SLC',
      class: 'webFormat',
    },
    {
      image: '/mar-apr-2023/sponsors/ufs.jpg',
      link: 'https://utahfoodservices.com/?utm_source=Mills+Publishing&utm_medium=Digital+Publication&utm_campaign=usuo+marketing+salt+lake+brewing+company',
      alt: 'Utah Food Services',
      class: 'webFormat',
    },
  ];

  const randomAd = millsAds[Math.floor(Math.random() * millsAds.length)];

  return (
    <>
      <hr />
      <br />
      <OutboundLink
        href={randomAd.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={randomAd.image}
          alt={randomAd.alt}
          className={randomAd.class}
        />
      </OutboundLink>
      <br />
      <br />
      <hr />
    </>
  );
}

export default clientRandomizer;
